import { render, staticRenderFns } from "./AdminUserManage.vue?vue&type=template&id=0b341dea&scoped=true"
import script from "./AdminUserManage.vue?vue&type=script&lang=js"
export * from "./AdminUserManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b341dea",
  null
  
)

export default component.exports